/* Custom Inventory Countdown: split-flap stock counters (section + Product-section blocks) */
(function () {
  if (!window.CICountdown) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ALPHA = " ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.-/&'";
    const DIGITS = '0123456789';
    const LEFT = '0123456789-';
    const VARIANT_EVENTS = ['variant:change', 'variant:changed', 'variantChange', 'on:variant:change', 'product:variant-change', 'theme:variant:change'];
    const pad = (n, len) => String(n).padStart(len, '0');
    const upper = (s) => String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const center = (s, len) => {
      s = upper(s).slice(0, len);
      const left = Math.floor((len - s.length) / 2);
      return (' '.repeat(left) + s).padEnd(len);
    };

    // Notice ?variant= URL changes made by the theme
    ['pushState', 'replaceState'].forEach((m) => {
      const orig = history[m];
      history[m] = function () {
        const r = orig.apply(this, arguments);
        document.dispatchEvent(new Event('cic:urlchange'));
        return r;
      };
    });

    /* ---------- Split-flap cell ---------- */
    class Cell {
      constructor(charset, opts) {
        this.cs = charset;
        this.maxSteps = opts.maxSteps || 10;
        this.shortest = !!opts.shortest;
        this.dur = reduce ? 0 : opts.speed || 110;
        const el = (this.el = document.createElement('span'));
        el.className = 'cic-flap';
        el.innerHTML =
          '<span class="cic-flap__half cic-flap__top"><i></i></span>' +
          '<span class="cic-flap__half cic-flap__bot"><i></i></span>' +
          '<span class="cic-flap__half cic-flap__top cic-flap__leaf"><i></i></span>' +
          '<span class="cic-flap__half cic-flap__bot cic-flap__leaf"><i></i></span>';
        const h = el.children;
        this.top = h[0].firstChild;
        this.bot = h[1].firstChild;
        this.leafTop = h[2];
        this.leafBot = h[3];
        this.cur = this.target = charset[0];
        this.paint(this.cur, this.cur);
      }
      paint(top, bot) {
        this.top.textContent = top;
        this.bot.textContent = bot;
      }
      norm(ch) {
        return this.cs.includes(ch) ? ch : this.cs[0];
      }
      setNow(ch) {
        this.cur = this.target = this.norm(ch);
        this.paint(this.cur, this.cur);
      }
      set(ch) {
        this.target = this.norm(ch);
        if (!this.running) this.run();
      }
      next() {
        const n = this.cs.length;
        const c = this.cs.indexOf(this.cur);
        const t = this.cs.indexOf(this.target);
        const dist = (t - c + n) % n;
        if (this.shortest) return this.cs[(c + (dist <= n / 2 ? 1 : -1) + n) % n];
        return dist > this.maxSteps ? this.cs[(t - this.maxSteps + 1 + n) % n] : this.cs[(c + 1) % n];
      }
      async run() {
        this.running = true;
        while (this.cur !== this.target) {
          const nx = this.next();
          if (this.dur) await this.flip(this.cur, nx);
          else this.paint(nx, nx);
          this.cur = nx;
        }
        this.running = false;
      }
      async flip(from, to) {
        this.paint(to, from);
        this.leafTop.firstChild.textContent = from;
        this.leafBot.firstChild.textContent = to;
        this.leafTop.style.visibility = this.leafBot.style.visibility = 'visible';
        const half = this.dur / 2;
        const fall = this.leafTop.animate([{ transform: 'rotateX(0deg)' }, { transform: 'rotateX(-90deg)' }], { duration: half, easing: 'ease-in', fill: 'forwards' });
        const land = this.leafBot.animate([{ transform: 'rotateX(90deg)' }, { transform: 'rotateX(0deg)' }], { duration: half, delay: half, easing: 'cubic-bezier(.3,1.5,.6,1)', fill: 'both' });
        await land.finished;
        this.paint(to, to);
        this.leafTop.style.visibility = this.leafBot.style.visibility = 'hidden';
        fall.cancel();
        land.cancel();
      }
    }

    function flapRow(el, len, charset, opts) {
      opts = opts || {};
      el.textContent = '';
      const cells = Array.from({ length: len }, () => {
        const c = new Cell(charset, opts);
        el.appendChild(c.el);
        return c;
      });
      return {
        len,
        set(str, instant) {
          const s = upper(str).padEnd(len).slice(0, len);
          cells.forEach((c, i) => (instant ? c.setNow(s[i]) : setTimeout(() => c.set(s[i]), (opts.stagger || 0) * i)));
        },
      };
    }

    // Digit counter that grows extra cells if the number needs them
    function countFlaps(el, minDigits, opts) {
      let row;
      return {
        set(q, instant) {
          const s = pad(Math.max(0, q), minDigits);
          if (!row || row.len !== s.length) {
            row = flapRow(el, s.length, DIGITS, Object.assign({}, opts, { shortest: true }));
            instant = true;
          }
          row.set(s, instant);
        },
      };
    }

    const statusMap = (d) => ({
      high: d.statusHigh, mid: d.statusMid, low: d.statusLow, out: d.statusOut,
      backorder: d.statusBackorder || d.statusOut, untracked: d.statusHigh,
    });

    /* ---------- Blocks ---------- */
    const BLOCKS = {
      station_board(el) {
        const f = countFlaps(el.querySelector('[data-role="count"]'), +el.dataset.minDigits || 2, { speed: +el.dataset.speed || 120 });
        return {
          update({ st, instant }) {
            el.dataset.level = st.level;
            f.set(st.q, instant);
          },
        };
      },

      departures_by_size(el, ctx) {
        const d = el.dataset;
        const board = el.querySelector('.cic-departboard');
        const rowsEl = el.querySelector('[data-role="rows"]');
        const S = statusMap(d);
        const labelN = +d.labelChars || 6;
        const maxRows = +d.maxRows || 8;
        const speed = +d.speed || 90;
        const statusN = Math.min(12, Math.max(2, ...Object.values(S).map((s) => (s || '').length)));
        const maxQ = Math.max(ctx.data.cap, ...Object.values(ctx.data.variants).map((v) => v.q || 0));
        const leftN = Math.max(2, String(maxQ).length);
        const optIndex = /^option[123]$/.test(d.labelSource) ? +d.labelSource.slice(6) - 1 : -1;
        board.style.setProperty('--label-n', labelN);
        board.style.setProperty('--left-n', leftN);
        board.style.setProperty('--cells', labelN + leftN + statusN);
        const rows = new Map();
        let key = '';
        const labelOf = (v) => (optIndex >= 0 && v.o[optIndex] ? v.o[optIndex] : v.title);
        // Labelled by an option: show the rows that match the selected variant's other options (e.g. sizes of the chosen colour)
        const visibleIds = () => {
          const cur = ctx.variant();
          let list = ctx.data.order.filter((id) => ctx.data.variants[id]);
          if (optIndex >= 0 && cur) list = list.filter((id) => ctx.data.variants[id].o.every((o, i) => i === optIndex || o === cur.o[i]));
          return list.slice(0, maxRows);
        };
        return {
          update({ full, instant }) {
            const list = visibleIds();
            const k = list.join(',');
            if (k !== key) {
              key = k;
              rows.clear();
              rowsEl.textContent = '';
              list.forEach((id) => {
                const row = document.createElement('div');
                row.className = 'cic-departboard__row';
                const g = ['label', 'left', 'status'].map((c) => {
                  const span = document.createElement('span');
                  span.className = 'cic-flaps cic-col-' + c;
                  row.appendChild(span);
                  return span;
                });
                rowsEl.appendChild(row);
                const r = {
                  el: row,
                  label: flapRow(g[0], labelN, ALPHA, { speed, maxSteps: 6, stagger: 30 }),
                  left: flapRow(g[1], leftN, LEFT, { speed, shortest: true }),
                  status: flapRow(g[2], statusN, ALPHA, { speed, maxSteps: 6, stagger: 30 }),
                };
                r.label.set(labelOf(ctx.data.variants[id]), instant);
                rows.set(id, r);
              });
            }
            list.forEach((id) => {
              const r = rows.get(id);
              const st = full ? ctx.fullState() : ctx.stateFor(ctx.data.variants[id]);
              r.el.dataset.level = st.level;
              r.el.toggleAttribute('data-selected', d.highlight === 'true' && id === ctx.variantId);
              r.left.set(st.kind === 'untracked' ? '-'.repeat(leftN) : pad(st.q, leftN), instant);
              r.status.set(S[st.kind] || '', instant);
            });
          },
        };
      },

      next_to_add_to_cart(el, ctx) {
        const d = el.dataset;
        const f = countFlaps(el.querySelector('[data-role="count"]'), +d.minDigits || 2, { speed: +d.speed || 110 });
        const line = el.querySelector('[data-role="line"]');
        const before = el.querySelector('[data-role="before"]');
        const after = el.querySelector('[data-role="after"]');
        const atc = el.querySelector('[data-role="atc"]');
        let last = null;
        let busy = false;
        const setAtc = () => {
          if (!atc || busy || !last) return;
          const soldOut = last.kind === 'out';
          atc.disabled = soldOut;
          atc.textContent = soldOut ? d.atcSoldOut : d.atcLabel;
        };
        if (atc) {
          atc.addEventListener('click', async () => {
            if (busy) return;
            busy = true;
            atc.setAttribute('aria-busy', 'true');
            const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            try {
              const res = await fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: +ctx.variantId, quantity: 1 }] }),
              });
              const json = await res.json();
              if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
              if (d.afterAdd === 'cart') {
                window.location.href = root + 'cart';
                return;
              }
              atc.textContent = d.atcAdded;
              ['cart:refresh', 'cart:updated', 'cart:change'].forEach((n) => document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: json })));
            } catch (e) {
              atc.textContent = e.message;
            }
            atc.removeAttribute('aria-busy');
            setTimeout(() => {
              busy = false;
              setAtc();
            }, 2200);
          });
        }
        return {
          update({ st, actual, instant }) {
            last = actual;
            el.dataset.level = st.level;
            const gone = st.kind === 'out' || st.kind === 'backorder';
            line.classList.toggle('is-out', gone);
            if (gone) {
              before.textContent = '';
              after.textContent = st.kind === 'out' ? d.soldOut : ctx.cfg.messages.backorder;
            } else {
              const high = st.level === 'high';
              before.textContent = high ? d.beforeHigh : d.beforeLow;
              after.textContent = high ? d.afterHigh : d.afterLow;
              f.set(st.q, instant);
            }
            setAtc();
          },
        };
      },

      dot_matrix_sign(el, ctx) {
        const sign = el.querySelector('[data-role="sign"]');
        const count = el.querySelector('[data-role="count"]');
        const status = el.querySelector('[data-role="status"]');
        const clock = el.querySelector('[data-role="clock"]');
        const S = statusMap(el.dataset);
        const glitch = (node, final, instant) => {
          clearInterval(node._cicT);
          if (instant || reduce) {
            node.textContent = final;
            return;
          }
          const t0 = performance.now();
          node._cicT = setInterval(() => {
            if (performance.now() - t0 > 420) {
              clearInterval(node._cicT);
              node.textContent = final;
              return;
            }
            node.textContent = [...final]
              .map((ch) => (/\d/.test(ch) ? Math.floor(Math.random() * 10) : ch === ' ' ? ' ' : ALPHA[1 + Math.floor(Math.random() * 26)]))
              .join('');
          }, 50);
        };
        if (clock) {
          const tick = () => {
            const t = new Date();
            clock.textContent = pad(t.getHours(), 2) + ':' + pad(t.getMinutes(), 2);
          };
          tick();
          ctx.timers.push(setInterval(tick, 15000));
        }
        return {
          update({ st, instant }) {
            el.dataset.level = sign.dataset.level = st.level;
            glitch(count, st.kind === 'untracked' ? '--' : pad(st.q, 2), instant);
            const s = upper(S[st.kind]);
            if (status.dataset.text !== s) {
              status.dataset.text = s;
              glitch(status, s, instant);
            }
          },
        };
      },

      traffic_light_flaps(el) {
        const d = el.dataset;
        const f = countFlaps(el.querySelector('[data-role="count"]'), +d.minDigits || 2, { speed: +d.speed || 120 });
        const W = { high: d.wordHigh, mid: d.wordMid, low: d.wordLow, out: d.wordOut, backorder: d.wordBackorder || d.wordOut, untracked: d.wordHigh };
        const wordEl = el.querySelector('[data-role="word"]');
        const len = Math.min(12, Math.max(1, ...Object.values(W).map((w) => (w || '').length)));
        const word = wordEl ? flapRow(wordEl, len, ALPHA, { speed: 70, maxSteps: 6, stagger: 50 }) : null;
        return {
          update({ st, instant }) {
            el.dataset.level = st.level;
            f.set(st.q, instant);
            if (word) word.set(center(W[st.kind], len), instant);
          },
        };
      },

      your_seat_is_waiting(el, ctx) {
        const d = el.dataset;
        const f = countFlaps(el.querySelector('[data-role="count"]'), +d.minDigits || 2, { speed: +d.speed || 110 });
        const status = el.querySelector('[data-role="status"]');
        const sku = el.querySelector('[data-role="sku"]');
        const S = statusMap(d);
        return {
          update({ st, instant }) {
            el.dataset.level = st.level;
            f.set(st.q, instant);
            status.textContent = S[st.kind] || '';
            const v = ctx.variant();
            if (sku && v) sku.textContent = sku.title = v.sku || v.title;
          },
        };
      },
    };

    /* ---------- One section instance ---------- */
    class Countdown {
      constructor(root) {
        this.root = root;
        this.sectionId = root.dataset.sectionId;
        this.productUrl = root.dataset.productUrl;
        this.design = root.hasAttribute('data-design-mode');
        this.note = root.querySelector('[data-role="note"]');
        this.data = JSON.parse(root.querySelector('[data-cic-data]').textContent);
        this.cfg = this.data.config;
        this.timers = [];
        this.variantId = String(this.detect() || this.data.selected);
        this.blocks = [...root.querySelectorAll('[data-cic-block]')]
          .map((el) => (BLOCKS[el.dataset.cicBlock] ? BLOCKS[el.dataset.cicBlock](el, this) : null))
          .filter(Boolean);
        // Width-aware layout without CSS container queries (they broke wrapper heights in some themes)
        const sized = [...root.querySelectorAll('.cic-block')];
        const fit = (b) => {
          const w = b.clientWidth;
          if (!w) return;
          b.style.setProperty('--cw', w + 'px');
          b.classList.toggle('cic-narrow', w < 560);
        };
        this.fitAll = () => sized.forEach(fit);
        this.fitAll();
        window.addEventListener('resize', this.fitAll);
        if (window.ResizeObserver) {
          this.ro = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target)));
          sized.forEach((b) => this.ro.observe(b));
        }
        this.visible = !this.cfg.animate || reduce;
        this.render(true);
        if (!this.visible) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries.some((e) => e.isIntersecting)) return;
              this.io.disconnect();
              this.visible = true;
              this.render(false);
            },
            { threshold: 0.35 }
          );
          this.io.observe(root);
        }
        this.listen();
        if (this.cfg.refresh > 0) this.timers.push(setInterval(() => !document.hidden && this.refresh(), this.cfg.refresh * 1000));
      }

      variant(id) {
        return this.data.variants[id || this.variantId];
      }
      fullState() {
        return { q: this.data.cap, level: 'high', kind: 'high' };
      }
      stateFor(v) {
        if (!v) return { q: 0, level: 'out', kind: 'out' };
        const q = Math.max(0, Number(v.q) || 0);
        if (!v.t) return { q, level: 'high', kind: 'untracked' };
        if (q <= 0) return { q: 0, level: 'out', kind: v.p === 'continue' ? 'backorder' : 'out' };
        const pct = (Math.min(q, this.data.cap) / this.data.cap) * 100;
        const level = pct > this.cfg.mid ? 'high' : pct > this.cfg.low ? 'mid' : 'low';
        return { q, level, kind: level };
      }

      render(instant) {
        const full = !this.visible;
        const v = this.variant();
        const actual = this.stateFor(v);
        const st = full && actual.kind !== 'untracked' && actual.q < this.data.cap ? this.fullState() : actual;
        const c = this.cfg;

        let reason = '';
        if (!v) reason = 'Hidden on your store: the selected variant could not be found.';
        else if (actual.kind === 'untracked' && c.untracked === 'hide') reason = "Hidden on your store: this variant doesn't track inventory.";
        else if (c.showBelow > 0 && actual.kind !== 'untracked' && actual.q > c.showBelow)
          reason = `Hidden on your store: ${actual.q} in stock is above your "Only show at or below" limit of ${c.showBelow}.`;
        if (this.design) {
          this.root.hidden = false;
          if (this.note) {
            this.note.hidden = !reason;
            this.note.textContent = reason;
          }
        } else {
          this.root.hidden = !!reason;
        }

        this.root.dataset.kind = actual.kind;
        const msg = (c.messages[actual.kind] || '').replace(/\[count\]/g, actual.q);
        this.root.querySelectorAll('.cic-msg').forEach((m) => {
          m.textContent = msg;
          m.dataset.level = actual.level;
        });
        this.blocks.forEach((b) => b.update({ st, actual, full, instant }));
      }

      detect() {
        for (const input of document.querySelectorAll('form[action*="/cart/add"] [name="id"], [name="id"][form]')) {
          if (input.value && this.data.variants[input.value]) return input.value;
        }
        const fromUrl = new URLSearchParams(window.location.search).get('variant');
        return fromUrl && this.data.variants[fromUrl] ? fromUrl : null;
      }

      listen() {
        const check = (id) => {
          id = id ? String(id) : this.detect();
          if (!id || id === this.variantId || !this.data.variants[id]) return;
          this.variantId = id;
          this.render(!this.visible);
        };
        this.onChange = () => setTimeout(() => check(), 30);
        this.onEvent = (e) => {
          const det = (e && e.detail) || {};
          const id = (det.variant && det.variant.id) || det.variantId || (det.id && this.data.variants[String(det.id)] ? det.id : null);
          setTimeout(() => check(id), 0);
        };
        this.onUrl = () => setTimeout(() => check(), 0);
        document.addEventListener('change', this.onChange, true);
        VARIANT_EVENTS.forEach((n) => document.addEventListener(n, this.onEvent));
        document.addEventListener('cic:urlchange', this.onUrl);
        window.addEventListener('popstate', this.onUrl);
        // Dawn-family themes
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
          this.unsub = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (ev) => check(ev && ev.data && ev.data.variant && ev.data.variant.id));
        }
        // Safety net for themes that change the variant silently
        this.timers.push(setInterval(() => check(), 1000));
      }

      // Re-fetch this section through the Section Rendering API for fresh stock levels
      async refresh() {
        try {
          const sep = this.productUrl.includes('?') ? '&' : '?';
          const res = await fetch(`${this.productUrl}${sep}section_id=${encodeURIComponent(this.sectionId)}&variant=${this.variantId}`, { headers: { Accept: 'text/html' } });
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const own = doc.getElementById(this.root.id);
          const script = (own && own.querySelector('[data-cic-data]')) || doc.querySelector('[data-cic-data]');
          if (!script) return;
          const fresh = JSON.parse(script.textContent);
          this.data.variants = fresh.variants;
          this.data.cap = fresh.cap;
          this.render(!this.visible);
        } catch (e) {
          /* keep showing the last known stock */
        }
      }

      destroy() {
        this.timers.forEach(clearInterval);
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.fitAll);
        document.removeEventListener('change', this.onChange, true);
        VARIANT_EVENTS.forEach((n) => document.removeEventListener(n, this.onEvent));
        document.removeEventListener('cic:urlchange', this.onUrl);
        window.removeEventListener('popstate', this.onUrl);
        if (typeof this.unsub === 'function') this.unsub();
      }
    }

    window.CICountdown = {
      init(root) {
        if (!root) return;
        if (root._cic) root._cic.destroy();
        root._cic = new Countdown(root);
      },
    };
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-cic]').forEach((r) => window.CICountdown.init(r)));
    document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-cic]').forEach((r) => r._cic && r._cic.destroy()));
  }
  const initAll = () => document.querySelectorAll('[data-cic]').forEach((r) => r._cic || window.CICountdown.init(r));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
